import React from 'react'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import TagList from '../../shared/TagList'
import './style.css'

const Keywords = ({ keywords }) => {
    return (
        <Block isRender={keywords?.length > 0}>
            <SectionCard icon="mdi:tag-multiple" titleKey="Keywords">
                <TagList items={keywords} />
            </SectionCard>
        </Block>
    )
}

export default Keywords

